import { Injectable } from '@angular/core'
import { CmsConverterService } from '../../../cms/services/cms-converter/cms-converter.service'
import { CmsComponent } from '@spartacus/core'
import { TrainingTeaserSliderComponentData } from './index'

@Injectable({ providedIn: 'root' })
export class TrainingTeaserSliderConverter extends CmsConverterService<TrainingTeaserSliderComponentData> {

  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      backgroundColor: formData.st_backgroundcolor?.value?.identifier,
    }
  }
}
